/**
 * @file 质押/解质押面板
 */
import { useState } from 'react';
import { useFm } from '@web3/base-hooks';
import { Tabs } from '@bfe/moly';
import HistoryIcon from '@/assets/images/bybitsol/history.svg';
import { OperationTab } from '@/types/common';
import { Stake } from './stake';
import { Account } from './account';
import { Airdrop } from './airdrop';
import { AccountInfoProvider } from '@/components/providers/accountInfo';
import { RefreshProvider } from '@/components/providers/refresh';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { useWallet } from '@/hooks/wallet';
import { useCoinInfoContext } from '@/hooks/useCoinInfo';
import { useParams } from '@web3/base-hooks';
import { Event } from '@/config/track-config';
import { Skeleton } from '@bfe/moly';
import { useInitCoinInfo } from './hooks';
import styles from './index.module.less';
import { appPath } from '@web3/base-utils';
import { scTrack } from '@web3/base-tracking';

export const Operation = ({ activity }) => {
  useInitCoinInfo();
  const { poolInfo } = usePoolInfoContext();
  const { isLogin, openLoginModal } = useWallet();
  const fm = useFm();
  const { locale } = useParams();
  const { isFetching: poolIsFetching } = usePoolInfoContext();
  const { isFetching: coinIsFetching } = useCoinInfoContext();

  const isReady = !poolIsFetching && !coinIsFetching;

  const [tab, setTab] = useState(OperationTab.Stake);

  if (!isReady)
    return <Skeleton.Bar style={{ marginTop: 38, width: 480, height: 377 }} />;

  const onChangeTab = (v: OperationTab) => {
    setTab(v);
  };

  const items = [
    {
      key: OperationTab.Stake,
      label: fm('investNow1'),
      children: tab === OperationTab.Stake && <Stake activity={activity} />,
    },
    {
      key: OperationTab.Account,
      label: fm('performance'),
      children: tab === OperationTab.Account && (
        <Account onChangeTab={onChangeTab} activity={activity} />
      ),
    },
  ];
  if (activity) {
    items.push({
      key: OperationTab.Airdrop,
      label: fm('airdrop'),
      children: tab === OperationTab.Airdrop && (
        <Airdrop activity={activity} onChangeTab={onChangeTab} />
      ),
    });
  }

  return (
    <RefreshProvider>
      <AccountInfoProvider tab={tab}>
        <div className={styles.container}>
          <div
            className={styles.history}
            onClick={() => {
              if (!isLogin) {
                openLoginModal();
                return;
              }
              if (window.top) {
                window.top.open(
                  `/${locale}${appPath}/history?chainId=${poolInfo.chainId}&poolId=${poolInfo.id}`
                );
              }
            }}
          >
            <HistoryIcon
              className={styles.assetIcon}
              data-spm-even={Event.Web3UserClick}
              data-spm-data={JSON.stringify({
                page_name: 'StakingWeb_bbSOLPagestake',
                button_name: 'Pool_Transactionrecord',
              })}
            />
            <div>{fm('tradeRecord')}</div>
          </div>

          <div className={styles.content}>
            <Tabs
              items={items}
              activeKey={tab}
              className={styles.tabs}
              tabTitleClassName={styles.tabsTitle}
              onChange={(v: string) => {
                setTab(v as OperationTab);
                const trackName = {
                  Stake: 'invest',
                  Account: 'performance',
                  Airdrop: 'airdrop',
                }[v];
                scTrack(Event.Web3UserClick, {
                  page_name: 'StakingWeb_bbSOLPage',
                  button_name: trackName,
                });
              }}
            />
          </div>
        </div>
      </AccountInfoProvider>
    </RefreshProvider>
  );
};
